"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Returns theme variables based on 'color' prop. This is useful
// in styled-components when you want to set a theme color based
// on props. The 'variant' option can be used to get the light
// or dark version of a color.
//
// Example:
// getThemeVariable('color', { variant: 'light' })({ color: 'primary', theme: { ... } })
// => theme.colorPrimaryLight
var getThemeVariable = function getThemeVariable(variable) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? undefined : _ref$variant;

  return function (props) {
    var theme = props.theme,
        color = props.color;
    variant = variant ? (0, _upperFirst.default)(variant) : undefined;
    color = (0, _upperFirst.default)(color);

    switch (variable) {
      case 'colorText':
        {
          return theme["colorTextOn".concat(color).concat(variant || '')];
        }

      case 'color':
      default:
        {
          return theme["color".concat(color).concat(variant || '')];
        }
    }
  };
};

var _default = getThemeVariable;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Theme/getThemeVariable.js